export default __webpack_public_path__ + "static/media/portfolio-206.467b0a70.jpg";